import * as React from 'react';
import {FunctionComponent} from 'react';
import {Heading, List, ListItem} from 'spectacle';
import {Slide} from '../components/slide';
import {Sprint} from '../model/sprint';

interface OwnProps {
    sprint: Sprint;
}

export const IdeaWeekLastWeek: FunctionComponent<OwnProps> = ({sprint}) => {
    return (
        <Slide major>
            <Heading size={1} textAlign="left" textColor="secondary">
                Idea week presentation: {sprint.employee.name}
            </Heading>
        </Slide>
    );
};
